import React, {useState} from 'react';
import Streaming from "../../components/Streaming";
import styles from "./AllChannels.module.css";
import ChannelsListFromService from "../../components/ChannelsList/ChannelsListFromService";
import {playlistService} from "../../services/playlist/PlaylistService";
import {M3uMedia} from "../../lib/m3u";
import {playlistShortlistService} from "../../services/playlist/PlaylistShortlistService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBookmark} from "@fortawesome/free-solid-svg-icons";
import {WordFilter} from "../../components/WordFilter";

function AllChannels() {

    const [filterWords, setFilterWords] = useState<string[]>([]);

    const addToShortlist = (channel: M3uMedia) => {
        playlistShortlistService.add(channel)
    };

    const ChannelActions = ({ data }: { data: M3uMedia }) => (
        <div className={styles.channelActions}>
            <div className={styles.tooltipContainer} title="Legg til shortlist">
                <FontAwesomeIcon
                    icon={faBookmark}
                    onClick={() => addToShortlist(data)}
                    className={styles.addIcon}
                />
            </div>
        </div>
    );

    const handleFilterSubmit = (words: string[]) => {
        setFilterWords(words);
    };

    return (
        <div className={styles.boxcontainer}>
            <div className={styles.box}>
                <WordFilter onSubmit={handleFilterSubmit}/>
                <ChannelsListFromService wordsFilter={filterWords} RowActionsComponent={ChannelActions} playlistService={playlistService}/>
            </div>
            <div className={`${styles.box}`}>
                <Streaming/>
            </div>
        </div>
    );
}

export default AllChannels;
